export default "__VITE_ASSET__CxigSZ5X__"